<template>
  <div
    class="h-36 w-40 flex flex-col justify-start items-center px-7 rounded-md pt-6 bg-white-dark cursor-pointer shadow-none hover:shadow-lg transition-all border "
    :class="isActive ? 'border-primary' : 'border-transparent'"
    @click="$emit('click')"
  >
    <slot></slot>
    <div
      class=" mt-4 font-semibold text-base whitespace-pre-wrap text-center"
      :class="isActive ? 'text-primary' : 'text-grey'"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "SidebarLink",
  props: {
    text: { type: String, required: true },
    isActive: { type: Boolean, default: false },
  },
  setup() {},
  emits: ["click"],
});
</script>
